import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

interface FooterProps {
  isHidden?: boolean;
  showFontSize?: boolean;
}

const Footer: React.FC<FooterProps> = ({ isHidden = false, showFontSize = false }) => {
  const { theme, fontSize, toggleTheme, setFontSize } = useTheme();

  return (
    <footer className={`footer ${isHidden ? 'footer--hidden' : ''}`}>
      <div className="footer__theme-toggle">
        <button
          className="footer__theme-btn"
          onClick={toggleTheme}
          aria-label={theme === 'light' ? 'Тамна тема' : 'Светла тема'}
        >
          {theme === 'light' ? (
            <svg
              viewBox="0 0 24 24"
              fill="currentColor"
              width="26"
              height="26"
            >
              <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
            </svg>
          ) : (
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              width="26"
              height="26"
            >
              <circle cx="12" cy="12" r="5"/>
              <line x1="12" y1="1" x2="12" y2="3"/>
              <line x1="12" y1="21" x2="12" y2="23"/>
              <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
              <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
              <line x1="1" y1="12" x2="3" y2="12"/>
              <line x1="21" y1="12" x2="23" y2="12"/>
              <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
              <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
            </svg>
          )}
        </button>
      </div>

      {showFontSize && (
        <div className="footer__font-size">
          <button
            className={`footer__font-btn footer__font-btn--small ${fontSize === 'small' ? 'footer__font-btn--active' : ''}`}
            onClick={() => setFontSize('small')}
            aria-label="Мала слова"
          >
            А
          </button>
          <button
            className={`footer__font-btn footer__font-btn--medium ${fontSize === 'medium' ? 'footer__font-btn--active' : ''}`}
            onClick={() => setFontSize('medium')}
            aria-label="Средња слова"
          >
            А
          </button>
          <button
            className={`footer__font-btn footer__font-btn--large ${fontSize === 'large' ? 'footer__font-btn--active' : ''}`}
            onClick={() => setFontSize('large')}
            aria-label="Велика слова"
          >
            А
          </button>
        </div>
      )}
    </footer>
  );
};

export default Footer;

